jQuery(function ($) {

    let $subscribeCustomApp = $('#subscribe-custom-app');

    if($subscribeCustomApp.length){
        new Vue({
            el: "#subscribe-custom-app",
            data: {
                loading: true,
                failedMessage: '',
                step: 1,
                form: {
                    agree: false,
                    name: '',
                    email: '',
                    phone: '',
                    city: '',
                    type: 'email',
                    language: 'ru'
                },
                show_custom_city: false,
                city_list: [{
                    'ru': 'Москва',
                    'en': 'Moscow',
                }, {
                    'ru': 'Санкт-Петербург',
                    'en': 'St. Petersburg',
                }, {
                    'ru': 'Пермь',
                    'en': 'Perm',
                }, {
                    'ru': 'Другой',
                    'en': 'Other',
                    'is_custom': true
                }],
                errors: {},
            },
            methods: {

                submitForm() {

                    this.loading = true;
                    this.failedMessage = '';

                    // Сброс ошибок
                    this.errors = {};

                    let data = this.form;

                    // perform validations on the non-Hosted Fields inputs
                    axios.post('/wp-admin/admin-ajax.php?action=subscribe_custom', data).then((response) => {

                        this.loading = false;
                        this.failedMessage = '';

                        if (response.data.result) {
                            this.step = 2;

                            let track_data = {
                                page_lang: ma_ajax.lang,
                                page_url: ma_ajax.request_url,
                                page_name: ma_ajax.title
                            }

                            if(response.data.email){
                                track_data.$email = response.data.email;
                            }
                            if(response.data.name){
                                track_data.$name = response.data.name;
                            }

                        }
                        else {
                            if(response.data.message.length){
                                this.failedMessage = response.data.message;
                            }
                        }

                    }).catch((error) => {
                        console.error(error);
                        this.loading = false;
                        Object.entries(error.response.data.errors).forEach((error) => {
                            this.errors[error[0]] = error[1];
                        });
                    });
                },

            },
            watch: {

            },
            mounted() {
                this.form.language = $('#form_subscribe_custom_language').val();
                this.form.city = this.city_list[0][this.form.language];
                this.loading = false;
            }
        });

    }

});

